import { PersonStamdata } from "../interfaces/stamdata";

/**
 * Medlemmets navn, sat sammen af de navnedele der findes.
 *
 * Returnerer en tom streng, hvis ingen af dem gør — så kaldere kan vælge deres egen faldbakke frem
 * for at vise et halvt navn. Reglen ligger ét sted, fordi den blev brudt to gange på samme måde:
 * `person.fornavne + " " + person.efternavn` gav navnet "null null" for et medlem uden Person-række
 * i portalen (ADV-288), og "null Petersen", hvis kun fornavnet manglede.
 */
export const fuldtNavn = (
  person: Pick<PersonStamdata, "fornavne" | "efternavn"> | null | undefined,
): string =>
  [person?.fornavne, person?.efternavn].filter(Boolean).join(" ").trim();
